export function initMarkerIo() {
    window.markerConfig = {
        project: "69de6cac4fc825431e69a14d",
        source: "snippet",
    };

    if (!window.__Marker) {
        window.__Marker = {};
        const queue: unknown[][] = [];
        const api: Record<string, (...args: unknown[]) => void> = { __cs: queue } as never;
        [
            "show",
            "hide",
            "isVisible",
            "capture",
            "cancelCapture",
            "unload",
            "reload",
            "isExtensionInstalled",
            "setReporter",
            "clearReporter",
            "setCustomData",
            "on",
            "off",
        ].forEach((method) => {
            api[method] = (...args: unknown[]) => {
                queue.push([method, ...args]);
            };
        });
        window.Marker = api as never;

        const script = document.createElement("script");
        script.async = true;
        script.src = "https://edge.marker.io/latest/shim.js";
        const firstScript = document.getElementsByTagName("script")[0];
        firstScript.parentNode!.insertBefore(script, firstScript);
    }
}
